<template>
    <div class="row">
        <div class="col-md-12">
            <vdtnet-table
                ref="table"
                :fields="fields"
                :opts="options"
                :key="bookingsKey"
                @viewBooking="viewBooking"
            />
        </div>
    </div>
</template>

<script>
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'
import moment from 'moment';

export default {
    name: 'AffiliateBookings',     
    components: {
        VdtnetTable,
    },
    data() {
        return {
            bookingsKey: 0,
            fields: {
                booking_ref: {
                    label: 'Booking Ref',
                    render: (data, type, row) => {
                        return `<router-link to="/bookings/${row.id}">${data || row.old_booking_id}</router-link>`;
                    }
                },
                customer_id: {
                    label: 'Customer',
                    render: (data, type, row) => {
                        return '-';
                    }
                },
                created_at: {
                    label: 'Date Booked',
                    render: (data) => moment(String(data)).format('DD/MM/YYYY')
                },
                id: {
                    label: 'Action',
                    render: (data, type, row) => {
                        return `<a href="/bookings/edit/${ row.id }" class="color-orange" data-action="viewBooking">Edit</a>`;
                    }
                }
            },
            options: {
                ajax: {
                    url: `${this.$api}affiliates/holiday/${this.$route.params.id}/bookings`,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': localStorage.getItem('token')
                    }
                },
                responsive: false,
                processing: true,
                searching: true,
                searchDelay: 1500,
                destroy: true,
                ordering: false,
                lengthChange: true,
                serverSide: true,
                dom: 'rtlip',
                autoWidth: false,
                lengthMenu: [ [5, 25, 50, 100, 500], [5, 25, 50, 100, 500] ],
                pageLength: 25,
                select: {
                    style: 'multi'
                }
            },
            
        } 
    },
    methods: {
        viewBooking(data) {
            this.$router.push({ name: 'booking-edit', params: { id: data.id }})
        },
    }       
}
</script>
